module.exports = __webpack_public_path__ + "static/media/daikon radish.2c15e1f7.jpg";